export const COMMENT_CREATION_MAX_IMAGE_NUMBER = 10;
